/**
 * El borrador del compositor, fuera del componente.
 *
 * Existe por la sesión: si caduca y no se puede renovar, la aplicación vuelve
 * al SSO --una navegación de verdad, que desmonta todo-- y lo que la persona
 * estaba escribiendo no puede perderse en el viaje. En `sessionStorage`
 * porque es de esta pestaña y solo tiene que durar ese ir y volver.
 *
 * Es una comodidad: si el almacenamiento no está, se escribe igual y
 * simplemente no se recupera.
 */
const KEY = "socio-amigo.chat.draft";

export const readDraft = (): string => {
  try {
    return sessionStorage.getItem(KEY) ?? "";
  } catch {
    return "";
  }
};

export const saveDraft = (text: string): void => {
  try {
    if (text === "") sessionStorage.removeItem(KEY);
    else sessionStorage.setItem(KEY, text);
  } catch {
    // Sin almacenamiento no hay borrador que guardar.
  }
};

/**
 * Devuelve a la caja un mensaje que no llegó a enviarse. No pisa lo que la
 * persona haya empezado a escribir después.
 */
export const restoreUnsent = (text: string): void => {
  if (text.trim() !== "" && readDraft().trim() === "") saveDraft(text);
};
